import { Stack, Text } from "@mantine/core";
import {
  FIT_AXIS_LABELS,
  FIT_REASON_PREVIEW_COUNT,
  FIT_REASON_STATUS_LABELS,
} from "../../constants/matching";
import type { FitReason } from "../../types/api";

export function FitReasonList({
  reasons,
  limit,
}: {
  reasons?: FitReason[] | null;
  limit?: number;
}) {
  const rows = (reasons ?? []).slice(0, limit ?? FIT_REASON_PREVIEW_COUNT);
  if (rows.length === 0) {
    return (
      <Text size="sm" c="dimmed">
        No fit details yet.
      </Text>
    );
  }
  return (
    <Stack gap="var(--axio-unit-4)">
      {rows.map((reason) => (
        <Text key={`${reason.axis}-${reason.status}`} size="sm">
          {FIT_AXIS_LABELS[reason.axis] ?? reason.axis}: {FIT_REASON_STATUS_LABELS[reason.status] ?? reason.status}
        </Text>
      ))}
    </Stack>
  );
}
